import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EditCompanyServicesData {
  serviceName: string;
  serviceDescription: string;
  serviceImage: string;
}

export interface initialStateType {
  ar: EditCompanyServicesData;
  en: EditCompanyServicesData;
}

const initialState: initialStateType = {
  ar: {
    serviceName: '',
    serviceDescription: '',
    serviceImage: '',
  },
  en: {
    serviceName: '',
    serviceDescription: '',
    serviceImage: '',
  },
};

const editCompanyServiceSlice = createSlice({
  name: 'editCompanyServices',
  initialState,
  reducers: {
    setEditCompanyServiceData: (
      state,
      action: PayloadAction<{
        serviceData: initialStateType;
      }>,
    ) => {
      const { serviceData } = action.payload;

      // state = serviceData; // Update project data for the specific language
      state.ar = serviceData.ar;
      state.en = serviceData.en;
    },
    clearEditCompanyServiceData: (state) => {
      state.ar = initialState.ar;
      state.en = initialState.en;
    },
    updateEditServiceFieldValue: (
      state,
      action: PayloadAction<{
        language: 'ar' | 'en';
        field: string;
        value: any;
        isSameValue: boolean;
      }>,
    ) => {
      const { language, field, value, isSameValue } = action.payload;
      state[language][field] = value;
      if (isSameValue) {
        state['ar'][field] = value;
        state['en'][field] = value;
      }
    },
  },
});

export const {
  setEditCompanyServiceData,
  updateEditServiceFieldValue,
  clearEditCompanyServiceData,
} = editCompanyServiceSlice.actions;

export const editCompanyServicesReducer = editCompanyServiceSlice.reducer;

export interface CompanyServiceState extends initialStateType {}
